const TextButton = ({usage, href, onClick, text}) => {
  if (href !== undefined) {
    return (
      <a href={href}><div className={`btn_${usage}`} onClick={onClick}>{text}</div></a>
    )
  } else {
    return (
      <a><div className={`btn_${usage}`} onClick={onClick}>{text}</div></a>
    )
  }
}

const SingleTextButton = ({type, usage, onClick, text}) => {
  return (
    <button type={type} className={`btn_${usage}`} onClick={onClick}>{text}</button>
  )
}

const ImageDivButton = ({usage, onClick}) => {
  return (
    <div className={`btn_${usage}`} />
  )
}

const ImageImgButton = ({src, onClick}) => {
  return (
    <img src={src} />
  )
}

export { TextButton, ImageDivButton, ImageImgButton, SingleTextButton }